import * as R from 'fp-ts/Record';

/**
 * Given an object with boolean values, set the key equal
 * to the ID of the item to `active`
 * @param active
 *
 * @example
 *   reduceToSelections(true)({a: true, b: false}, {id: 'b'})
 *   // {a: true, b: true}
 */
export const reduceToSelections =
  (active: boolean) =>
  (existingSelection: Record<string, boolean>, item: Record<'id', string>) => {
    return R.upsertAt(item.id, active)(existingSelection);
  };
